import { includes } from "lodash";
import { useEffect, useState } from "react";
import { aggregateEditableColumns } from "../../../../services/authorizationService";
import { getValueOrDash } from "../../../../utils/helpers";
import * as actionType from "../../../../store/ActionTypes";
import { dispatcher } from "../../../../store/storeHelpers";
import { toast } from "react-toastify";
import AsyncSelectField from "../../inputs/AsyncSelectField";
import { getPortList } from "../../../../services/dataService";
import { getUser } from "../../../../services/authService";
import { updateAggregateShipment, uploadAggregateBookingDocument } from "../../../../services/aggregateDataService";
import { Button } from "react-bootstrap";
import pdfIcon from "../../../../assets/icons/pdfIcon.png";
import moment from "moment";
import Select from "react-select";
import { updateBookingNumAggregate } from "../../../../services/aggregateDataService";
import Tooltips from "../../../Custom Components/tooltip";
import { getAggregateDailyContainerPlanning } from "../../../../services/aggregateDataService";
import { aggregateDataCreatorForStore } from "../../../../utils/dataFilter";
import * as  actionTypes from "../../../../store/ActionTypes"
import { viewSIDoc } from "../../../../services/tractorDataService";
import DeleteModalDocument from "../../DeleteModalDocument";

const AggregateEditableCell = ({
  value: initialValue,
  row: { original, subRows },
  column: { id },
  showDisableCellForJD,
  setShowDisableCellForJD,
  transporterList,
  allowToEdit,
  date,
  allowToHold,
  setholdmodal,
  setCountData,
}) => {
  const [value, setValue] = useState(initialValue);
  const [showBookUpdate, setShowBookUpdate] = useState(false);
  const [typing, setTyping] = useState(false);
  const [disableBookingUpdateBtn, setDisableBookingUpdateBtn] = useState(false)
  const [disableBookingDocBtn, setDisableBookingDocBtn] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const user = getUser();

  let counterLabel = []
  let counterValue = {
    Booked: 0,
    Pending: 0,
    Approved: 0,
    Cancelled: 0,
    Not_Booked: 0,
    Hold:0,
  }
  let checkstatus= "";

  useEffect(() => {
    if (includes(user.role, "jd_team")) {
      setShowDisableCellForJD(true);
    }
  }, [user, setShowDisableCellForJD]);

  const onChange = (e) => {
    if(e.target.name==="Container_Count"){
      if(e.target.value !== "0"){
        setValue(e.target.value);
        setTyping(true);
      }
    }
    else{
      setValue(e.target.value);
      setTyping(true);
    }
  };
  const handleDocumentView = async(docName) => {
    try {
      const response = await viewSIDoc(docName)
      window.open(response.data.Message)
    } catch (error) {
      toast.error('Unable to view booking Document')
    }
  };

  const containerTypeOption = [
    { value: "40HC", label: "40HC" },
    { value: "20GP", label: "20GP" },
  ];

  const carrierTypeOption = [
    { value: "OOCL", label: "OOCL" },
    { value: "ONE", label: "ONE" },
    { value: "MAERSK", label: "MAERSK" },
    { value: "HAPAG", label: "HAPAG" },
    { value: "CMA CGM", label: "CMA CGM" },
    { value: "TS LINES", label: "TS LINES" },
    { value: "MSC", label: "MSC" },
    { value: "OTHERS", label: "OTHERS" },
  ];

  const preventNegativeValues = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

    const handleKeyPress = (event) => {
      const charCode = event.which || event.keyCode;

      // Allow only alphabets (A-Z and a-z)
      if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    };

  async function updateBookingNumHandler() {
    try {
      setDisableBookingUpdateBtn(true)
      await updateBookingNumAggregate({
        assignContainerPlanningAggregateId:
          original["AssignContainerAggregateId"],
        bookingNo: value,
        bookedBy: getUser().uid,
      });
      dispatcher(actionType.AGGREGATE_UPDATE_BOOKING_NO, {
        Country: original["Country"],
        DailyContainerPlanningAggregateId:
          original["DailyContainerPlanningAggregateId"],
        AssignContainerPlanningAggId: original["AssignContainerPlanningAggId"],
        bookingNo: value,
      });
      setDisableBookingUpdateBtn(false)
      toast.success("Booking Number Updated");
      const response = await getAggregateDailyContainerPlanning(
        moment(date).format("YYYY-MM-DD")
      );
      dispatcher(
        actionTypes.AGGREGATE_BOOKING_LOADED,[]
      );
      dispatcher(
        actionTypes.AGGREGATE_BOOKING_LOADED,
        aggregateDataCreatorForStore(response.data.Resultset1)
      );
      for (let i = 0; i < response.data.Resultset2.length; i++) {
        counterLabel.push(response.data.Resultset2[i]["STATUS"])
        if(response.data.Resultset2[i]["STATUS"] === "Booked"){
          counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
        }
        if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
          counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
        }
        if(response.data.Resultset2[i]["STATUS"] === "Pending"){
          counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
        }
        if(response.data.Resultset2[i]["STATUS"] === "Approved"){
          counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
        }
        if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
          counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
        }
        if(response.data.Resultset2[i]["STATUS"] === "Hold"){
          counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
        }
      }
      setCountData({label : counterLabel, counterData : counterValue})
    } catch (error) {
      if(error?.response?.data?.Message==="Record Not Found"){
        window.location.reload();
      }
      else {
        setDisableBookingUpdateBtn(false);
        toast.error(
          "Unable to update booking number or enter booking number from booking module."
        );
      }
    }
  }

  const handleUpdatedFileSubmit = async () => {
    if (value && value.size > 0) {
      try {
        var formData = new FormData();
        formData.append("_files", value);
        setDisableBookingDocBtn(true)
        const response = await uploadAggregateBookingDocument(
          formData,
          original.DailyContainerPlanningAggregateId
        );
        original["BookingDocument"] = response.data.Result.Result
        setShowBookUpdate(false)
        setDisableBookingDocBtn(false)
        toast.success("Booking doc uploaded");
      } catch (error) {
        setDisableBookingDocBtn(false)
      }
    } else {
      toast.warn("Please select a file");
    }
  };

  const onBlur = async () => {
    setTyping(false);
    if (
      id === "PartNumber" ||
      id === "Category" ||
      id === "SubCategory" ||
      id === "Remark" 
    ) {
      if (original[id] !== value) {
        try {
          const apiresponse = await updateAggregateShipment({
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PrevVal: getValueOrDash(original[id]),
          });
          toast.success(`Column updated with ${value}`);
          if(apiresponse.data.IsBooked){
            checkstatus="Booked"
          }
          else{
            checkstatus="Not Booked"
          }
          if(checkstatus!==original["STATUS"]){
            const response = await getAggregateDailyContainerPlanning(
              moment(date).format("YYYY-MM-DD")
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,[]
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,
              aggregateDataCreatorForStore(response.data.Resultset1)
            );
            for (let i = 0; i < response.data.Resultset2.length; i++) {
              counterLabel.push(response.data.Resultset2[i]["STATUS"])
              if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
              }
            }
            setCountData({label : counterLabel, counterData : counterValue})
          }
        } catch (error) {
          if(error?.response?.data?.Message==="Record Not Found"){
            window.location.reload();
          }
          else{
            toast.error("Unable to update.. Try again");
          }
        }
      }
    }
    if (
      id === "Quantity" ||
      id === "Container_Count" 
    ) {
      if (original[id] !== value) {
       
        if(value.trim() !== '')
        {  
          try {
             const apiresponse = await updateAggregateShipment ({
              DailyContainerPlanningAggregateId: original.DailyContainerPlanningAggregateId,
              Country: original.Country,
              ColumnName: id,
              Value: value,
              PreviousValue: getValueOrDash(original[id]),
            });
            toast.success(`Column updated with ${value}`);
            if(apiresponse.data.IsBooked){
              checkstatus="Booked"
            }
            else{
              checkstatus="Not Booked"
            }
            if(checkstatus!==original["STATUS"] || id === "Container_Count" ){ 
              const response = await getAggregateDailyContainerPlanning(
              moment(date).format("YYYY-MM-DD")
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,[]
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,
              aggregateDataCreatorForStore(response.data.Resultset1)
            );
            for (let i = 0; i < response.data.Resultset2.length; i++) {
              counterLabel.push(response.data.Resultset2[i]["STATUS"])
              if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
              }
              if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
              }
            }
            setCountData({label : counterLabel, counterData : counterValue})}
           
          } catch (error) {
            if(error?.response?.data?.Message==="Record Not Found"){
              window.location.reload();
            }
            else{
              toast.error("Unable to update.. Try again");
            }
          }
        }  
      }
    }

    if (id === "Port_Of_Destination" || id === "final_destination" || id === "Container_Type" || id === "Transporter") {
      if (original[id] !== value) {
        try {
          dispatcher(actionType.AGGREGATE_INSERT_DROPDOWN_DATA, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PrevVal: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS
          });
          setTyping(false);
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
      }
    }
    if(id === "Country"){
      if (original[id] !== value){
        if(value.trim()!==''){
          try{
            await updateAggregateShipment({
              DailyContainerPlanningAggregateId:
                original.DailyContainerPlanningAggregateId,
              Country: original.Country,
              ColumnName: id,
              Value: value,
              PrevVal: getValueOrDash(original[id]),
            })
            toast.success(`Column updated with ${value}`)
            const response = await getAggregateDailyContainerPlanning(
              moment(date).format("YYYY-MM-DD")
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,[]
            );
            dispatcher(
              actionTypes.AGGREGATE_BOOKING_LOADED,
              aggregateDataCreatorForStore(response.data.Resultset1)
            );
          }
          catch(error){
            toast.error("Something went wrong..")
          }
        }
        else{
          toast.warn("Country cannot be null")
          const response = await getAggregateDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          dispatcher(
            actionTypes.AGGREGATE_BOOKING_LOADED,[]
          );
          dispatcher(
            actionTypes.AGGREGATE_BOOKING_LOADED,
            aggregateDataCreatorForStore(response.data.Resultset1)
          );
        }
      }
    }
    if(id === "VSL_VOY"){
      if (original[id] !== value) {
        try {
          dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PreviousValue: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS
          });
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
      }
    }
    if(id === "Quantity"){
      if (original[id] !== value) {
        if(value.trim() !== '')
        {
        dispatcher(actionType.AGGREGATE_UPDATE_BOOKING_QTY,{
          DailyContainerPlanningAggregateId: original.DailyContainerPlanningAggregateId,
          Country : original.Country,
          Quantity: value
        })
      }
      }
    }
    if(id === "Container_Count"){
      if (original[id] !== value) {
        if(value.trim() !== '')
        {
        dispatcher(actionType.AGGREGATE_UPDATE_BOOKING_CONTAINER_QTY,{
          DailyContainerPlanningAggregateId: original.DailyContainerPlanningAggregateId,
          Country : original.Country,
          Container_Count: value
        })
      }
      }
    }
    if (id === "ETD") {
      if (original[id] !== value) {
        if (!moment(value).isAfter(original.ETA)) {
        try {
          dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PreviousValue: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS
          });
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
      }
      else
      {
        toast.error("ETA cannot be lesser than ETD");
        const response = await getAggregateDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
     
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,[]
        );
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,
          aggregateDataCreatorForStore(response.data.Resultset1)
        );
      }
      }
      if (original.JD_Stuffing_Date) {
        const originTimeDiff = moment(value).diff(
          original.JD_Stuffing_Date,
          "days"
        );
        if (originTimeDiff > 0) {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `${originTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }
        if (originTimeDiff > 12) {
          const groundRentTimeDiff = originTimeDiff - 12;
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `${groundRentTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }

        if (original.Carrier === "OOCL" || original.Carrier === "ONE") {
          if (originTimeDiff > 26) {
            const detentionDiff = originTimeDiff - 26;

            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiff} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          original.Carrier === "MAERSK" ||
          original.Carrier === "HAPAG" ||
          original.Carrier === "CMA CGM"
        ) {
          if (originTimeDiff > 22) {
            const detentionDiffData = originTimeDiff - 22;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          original.Carrier === "TS LINES" ||
          original.Carrier === "MSC" ||
          original.Carrier === "OTHERS"
        ) {
          if (originTimeDiff > 15) {
            const detentionDiffData = originTimeDiff - 15;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
      }
      // if (original.ETA) {
      //   if (moment(value).isAfter(original.ETA)) {
      //     alert("ETA cannot be lesser than ETD");
      //   }
      // }
    }

    if (id === "ETA") {
      if (original[id] !== value) {
     
        if (!moment(value).isBefore(original.ETD))
        {

        try {
          dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PreviousValue: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS

          });
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
        }
        else
        {
          
          toast.error("ETA cannot be lesser than ETD");
          const response = await getAggregateDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          
          dispatcher(actionTypes.AGGREGATE_COLUMN_UPDATED, []);
          dispatcher(
            actionTypes.AGGREGATE_COLUMN_UPDATED,
            aggregateDataCreatorForStore(response.data.Resultset1)
          );

        }
      }
      // if (moment(value).isBefore(original.ETD)) {
      //   alert("ETA cannot be lesser than ETD");
      // }
    }

    if (id === "Carrier") {
      if (original[id] !== value) {
        try {
          dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PreviousValue: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS

          });
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
      }
      if (original.JD_Stuffing_Date && original.ETD) {
        const originTimeDiff = moment(original.ETD).diff(
          original.JD_Stuffing_Date,
          "days"
        );
        if (originTimeDiff > 0) {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `${originTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS

              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }
        if (originTimeDiff > 12) {
          const groundRentTimeDiff = originTimeDiff - 12;
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `${groundRentTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }

        if (value === "OOCL" || value === "ONE") {
          if (originTimeDiff > 26) {
            const detentionDiff = originTimeDiff - 26;

            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiff} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          value === "MAERSK" ||
          value === "HAPAG" ||
          value === "CMA CGM"
        ) {
          if (originTimeDiff > 22) {
            const detentionDiffData = originTimeDiff - 22;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          value === "TS LINES" ||
          value === "MSC" ||
          value === "OTHERS"
        ) {
          if (originTimeDiff > 15) {
            const detentionDiffData = originTimeDiff - 15;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
      }
    }

    if (id === "JD_Stuffing_Date") {
      const originTimeDiff = moment(original.ETD).diff(value, "days");
      if (original[id] !== value) {
        try {
          dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
            DailyContainerPlanningAggregateId:
              original.DailyContainerPlanningAggregateId,
            Country: original.Country,
            ColumnName: id,
            Value: value,
            PreviousValue: getValueOrDash(original[id]),
            date:date,
            setCountData:setCountData,
            Status:original.STATUS
          });
        } catch (error) {
          toast.error("Unable to update.. Try again");
        }
      }
      if (original.ETD) {
        if (originTimeDiff > 0) {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `${originTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Origin_Transit_Time",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Origin_Transit_Time"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }
        if (originTimeDiff > 12) {
          const groundRentTimeDiff = originTimeDiff - 12;

          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `${groundRentTimeDiff} days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        } else {
          if (original[id] !== value) {
            try {
              dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                DailyContainerPlanningAggregateId:
                  original.DailyContainerPlanningAggregateId,
                Country: original.Country,
                ColumnName: "Ground_Rent_Days",
                Value: `0 days`,
                PreviousValue: getValueOrDash(original["Ground_Rent_Days"]),
                date:date,
                setCountData:setCountData,
                Status:original.STATUS
              });
            } catch (error) {
              toast.error("Unable to update.. Try again");
            }
          }
        }

        if (original.Carrier === "OOCL" || original.Carrier === "ONE") {
          if (originTimeDiff > 26) {
            const detentionDiff = originTimeDiff - 26;

            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiff} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          original.Carrier === "MAERSK" ||
          original.Carrier === "HAPAG" ||
          original.Carrier === "CMA CGM"
        ) {
          if (originTimeDiff > 22) {
            const detentionDiffData = originTimeDiff - 22;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS
                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
        if (
          original.Carrier === "TS LINES" ||
          original.Carrier === "MSC" ||
          original.Carrier === "OTHERS"
        ) {
          if (originTimeDiff > 15) {
            const detentionDiffData = originTimeDiff - 15;
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `${detentionDiffData} days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          } else {
            if (original[id] !== value) {
              try {
                dispatcher(actionType.AGGREGATE_COLUMN_UPDATED, {
                  DailyContainerPlanningAggregateId:
                    original.DailyContainerPlanningAggregateId,
                  Country: original.Country,
                  ColumnName: "Approx_container_detention",
                  Value: `0 days`,
                  PreviousValue: getValueOrDash(
                    original["Approx_container_detention"]
                  ),
                  date:date,
                  setCountData:setCountData,
                  Status:original.STATUS

                });
              } catch (error) {
                toast.error("Unable to update.. Try again");
              }
            }
          }
        }
      }
    }
  };

  const handleFileSubmit = async () => {
    if (value && value.size > 0) {
      try {
        var formData = new FormData();
        formData.append("_files", value);
        setDisableBookingDocBtn(true)
        const dataresponse = await uploadAggregateBookingDocument(
          formData,
          original.DailyContainerPlanningAggregateId
        );
        original["BookingDocument"] = dataresponse.data.Result.Result
        const response = await getAggregateDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,[]
        );
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,
          aggregateDataCreatorForStore(response.data.Resultset1)
        );
        for (let i = 0; i < response?.data?.Resultset2?.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        setShowBookUpdate(false)
        setDisableBookingDocBtn(false)
        toast.success("Booking doc uploaded");
      } catch (error) {
        if(error?.response?.data?.Message==="Record Not Found"){
          window.location.reload();
        }
        setDisableBookingDocBtn(false)
      }
    } else {
      toast.warn("Please select a file");
    }
  };

  const handleDeleteBookingFile = async () => {
   
    setShowDeleteModal({ status: true});
  };

  const convertBitToBool = (bitVal) => {
    if (bitVal === true) {
      return 1;
    } else return 0;
  };

  const onToggle = async (val) => {
    let idList = ""
    for (let i = 0; i < original.subRows.length; i++) {
      if(i !== original.subRows.length - 1){
        idList += original.subRows[i].DailyContainerPlanningAggregateId + ","
      }else{
        idList += original.subRows[i].DailyContainerPlanningAggregateId
      }
    }
    if (original[id] !== val) {
      dispatcher(actionType.AGGREGATE_COLUMN_UPDATED_FOR_INSPECTION, {
        DailyContainerPlanningAggregateId:
          idList,
        Country: original.Country,
        ColumnName: id,
        Value: convertBitToBool(val),
        PrevVal: getValueOrDash(original[id]),
      });
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (
    includes(aggregateEditableColumns, id) &&
    subRows.length !== 0 &&
    includes(user.role, "jd_team")
  ) {
    if (
      id === "Port_Of_Destination" ||
      id === "Country" ||
      id === "BookingDocument" ||
      id === "Container_Type" ||
      id === "Remark" ||
      id === "VSL_VOY" ||
      id === "final_destination" ||
      id === "Carrier" ||
      id === "Transporter" ||
      id === "ETD" ||
      id === "ETA" ||
      id === "Factory_In_Date" ||
      id === "Factory_Out_Date" ||
      id === "JD_Stuffing_Date" ||
      id === "Ground_Rent_Days" ||
      id === "Origin_Transit_Time" ||
      id === "Approx_container_detention" ||
      id === "Booking_Doc" ||
      id === "Delete"
    ) {
      return "";
    }
  }
  if (
    includes(aggregateEditableColumns, id) &&
    subRows.length !== 0 
    // includes(user.role, "ata_pune")
  ) {
    if (id === "Inspection") {
      return (
        <div className="button button-check r">
          <input
            type="checkbox"
            className="checkbox"
            checked={original.subRows[0]["Inspection"] === "1"}
            onChange={(e) => setValue(e.target.checked)}
            onClick={(e) => {
              onToggle(e.target.checked);
            }}
            disabled={!allowToEdit}
          />
          <div className="knobs">
            <span></span>
          </div>
          <div className="layer"></div>
        </div>
      );
    } else if (
      id === "Date" ||
      id === "Port_Of_Destination" ||
      id === "Container_Type" ||
      id === "Remark" ||
      id === "VSL_VOY" ||
      id === "final_destination" ||
      id === "Carrier" ||
      id === "Transporter" ||
      id === "ETD" ||
      id === "ETA" ||
      id === "Factory_In_Date" ||
      id === "Factory_Out_Date" ||
      id === "JD_Stuffing_Date" ||
      id === "Ground_Rent_Days" ||
      id === "Origin_Transit_Time" ||
      id === "Approx_container_detention" ||
      id === "Booking_Number" ||
      id === "Booking_Doc" ||
      // id === "Remark" ||
      id === "Delete"
    ) {
      return "";
    } else
      return (
        <input
          value={value}
          className="table_input"
          onChange={onChange}
          onBlur={onBlur}
          disabled={!allowToEdit}
        />
      );
  } else if (id === "Inspection") {
    if (value === "1" || value === true) {
      return "YES";
    } else return "NO";
  } else if (id === "Port_Of_Destination") {
    if (original["Container_Count"] !== "") {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <AsyncSelectField
            dbKey={"name"}
            lableKey={"name"}
            value={{ name: value }}
            onBlur={onBlur}
            onChange={(option) => setValue(option.name)}
            getOptionsAPI={getPortList}
            fieldUsedIn="table"
            disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            setvalue={setValue}
            original={original}
          />
        </Tooltips>
      );
    } else return "-";
  } else if (id === "Container_Type") {
    if (original["Container_Count"] !== "") {
      return (
        <Select
          options={containerTypeOption}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          placeholder="Select..."
          className="Container_Type_dropdown"
          maxMenuHeight={80}
          name="Container_Type"
          value={{ label: value }}
          onBlur={onBlur}
          onChange={(option) => setValue(option["label"])}
          isDisabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
        />
      );
    } else return "";
  } else if (id === "VSL_VOY") {
    if (original["Container_Count"] !== "") {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return "";
  } else if (id === "final_destination") {
    if (original["Container_Count"] !== "") {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <AsyncSelectField
            dbKey={"name"}
            lableKey={"name"}
            value={{ name: value }}
            onBlur={onBlur}
            onChange={(option) => setValue(option.name)}
            getOptionsAPI={getPortList}
            fieldUsedIn="table"
            disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            setvalue={setValue}
            original={original}
          />
        </Tooltips>
      );
    } else return "-";
  } else if (id === "Carrier") {
    if (original["Container_Count"] !== "") {
      return (
        <Select
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          options={carrierTypeOption}
          placeholder="Select..."
          className="Carrier_Type_dropdown"
          maxMenuHeight={200}
          name="Carrier"
          value={{ label: value }}
          onBlur={onBlur}
          onChange={(option) => setValue(option["label"])}
          isDisabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
        />
      );
    } else return "";
  } else if (id === "Transporter") {
    const isDisabled = original["BookingDocument"] ? false : true 
    if (original["Container_Count"] !== "") {
      return (
        <Select
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          options={transporterList}
          placeholder=""
          className="Carrier_Type_dropdown"
          maxMenuHeight={200}
          name="Transporter"
          value={ isDisabled ? "" :  {TransporterName : value}}
          getOptionLabel={(option) => option.TransporterName}
          getOptionValue={(option) => option.TransporterName}
          onBlur={onBlur}
          onChange={(option) => setValue(option["TransporterName"])}
          isDisabled={showDisableCellForJD || !allowToEdit || isDisabled || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
        />
      );
    } else return "";
  } else if (
    id === "ETD" ||
    id === "ETA" ||
    id === "Factory_In_Date" ||
    id === "Factory_Out_Date" ||
    id === "JD_Stuffing_Date"
  ) {
    if (original["Container_Count"] !== "") {
      return (
        <div>
          <input
            type="date"
            className="table_input"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            name={id}
            disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
          />
        </div>
      );
    } else return "";
  } else if (
    id === "Ground_Rent_Days" ||
    id === "Origin_Transit_Time" ||
    id === "Approx_container_detention"
  ) {
    if (original["Container_Count"] !== "") {
      return (
        <div>
          <input
            type="text"
            className="table_input"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            name={id}
            disabled={original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
          />
        </div>
      );
    } else return "";
  } else if (id === "Remark") {
    if (original["Container_Count"] !== "") {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return "-";
  }else if (id === "PartNumber") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return "-";
  } else if (id === "Category") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return "-";
  }else if (id === "Quantity") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="number"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              onKeyDown={preventNegativeValues}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return value;
  }
  else if(id === "Holdtoggle") {
    if(original["IsParentRow"]!=1){
      return (
        <div className="button button-check r">
          <input
            type="checkbox"
            className="checkbox"
            checked={original["STATUS"] === "Hold"}
            onChange={() =>{}}
            onClick={(e)=>setholdmodal(original.DailyContainerPlanningAggregateId)}
            disabled={!allowToEdit || original["STATUS"]==="Hold" && !allowToHold || !allowToHold || original["IsFactoryOut"] === 1 }
          />
          <div className="knobs">
            <span></span>
          </div>
          <div className="layer"></div>
        </div>
      );
    }
    else return "-";
  }
  else if(id === "HoldReason"){
    return(
      <Tooltips content={value} direction="left">
      <input
        type="text"
        className="table_input"
        value={value}
        name="HoldReason"
      disabled={true}
      />
    </Tooltips>
    )
   
  } 
  else if (id === "Container_Count") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="number"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              onKeyDown={preventNegativeValues}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return value;
  }else if (id === "Country") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              onKeyPress={handleKeyPress}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return value;
  }else if (id === "SubCategory") {
    if ( subRows.length === 0 ) {
      return (
        <Tooltips content={value} direction="left" typing={typing}>
          <div>
            <input
              type="text"
              className="table_input"
              style={{textAlign:"left"}}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              name={id}
              disabled={showDisableCellForJD || !allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            />
          </div>
        </Tooltips>
      );
    } else return "-";
  }
   else if (id === "Booking_Number") {
    if (allowToEdit) {
      if (original["Container_Count"] !== "") {
        return (
          <div>
            <input
              type="text"
              className="table_input"
              value={value}
              onChange={onChange}
              name={id}
              disabled={!allowToEdit}
            />
            <Button
              className="btn-primary btn-pill btn-sm mr4"
              onClick={updateBookingNumHandler}
              disabled={!allowToEdit || disableBookingUpdateBtn || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
            >
              Update
            </Button>
          </div>
        );
      } else return "";
    } else {
      if (value) {
        return value;
      } else return "";
    }
  }
  else if(id==="STATUS" && original[id]==="Hold"){   
    return(
      <b style={{color:"#E38846",fontFamily:"poppins"}}>{original[id]}</b>
    )     
}
   else if (id === "Booking_Doc") {
    if (original["BookingDocument"]) {
      if (allowToEdit) {
        return (
          <div>
            {!showBookUpdate && (
              <>
                {" "}
                <span
                  className="doc-view-table"
                  onClick={() =>
                    handleDocumentView(original["BookingDocument"])
                  }
                >
                  <img className="doc-img" src={pdfIcon} alt="pdficon" />
                  View document
                </span>
              {/*   <Button
                  className="btn-primary btn-pill btn-sm mr4"
                  size="sm"
                  onClick={() => setShowBookUpdate(true)}
                  disabled={!allowToEdit}
                >
                  Update
                </Button> */}
                <button
                  className="deleteBtn__TractorBookingDoc"
                  tabIndex="-1"
                  onClick={handleDeleteBookingFile}
                  disabled={!allowToEdit || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
                >
                  <i className="bx bxs-trash deleteBtn_bookingDoc_Tractor"></i>
                </button>
              </>
            )}

            {showBookUpdate && (
              <>
                {" "}
                <input
                  type={"file"}
                  onChange={(e) => setValue(e.target.files[0])}
                  className="table-file-input"
                  accept="application/pdf"
                  disabled={showDisableCellForJD || !allowToEdit}
                />
                <Button
                  size="sm"
                  onClick={handleUpdatedFileSubmit}
                  disabled={showDisableCellForJD || !allowToEdit || disableBookingDocBtn || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
                >
                  Upload
                </Button>{" "}
              </>
            )}
                 {showDeleteModal && (
        <DeleteModalDocument
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          label="delete plan"
          dataType="Aggregate"
          Id={original.DailyContainerPlanningAggregateId}
          ColumnName="BookingDocument"
          PreviousValue={getValueOrDash(original["BookingDocument"])}
          Value= ""
          date={date}
          setCountData={setCountData}
        />
      )}
          </div>
        );
      } else {
        return (
          <span
            className="doc-view-table"
            onClick={() => handleDocumentView(original["BookingDocument"])}
          >
            <img className="doc-img" src={pdfIcon} alt="pdficon" />
            View document
          </span>
        );
      }
    } else {
      if (original["Container_Count"] !== "") {
        if (original["Booking_Number"]) {
          return (
            <>
              <input
                type={"file"}
                onChange={(e) => setValue(e.target.files[0])}
                className="table-file-input"
                accept="application/pdf"
                disabled={showDisableCellForJD || !allowToEdit}
              />
              <Button
                size="sm"
                onClick={handleFileSubmit}
                disabled={showDisableCellForJD || !allowToEdit || disableBookingDocBtn || original["STATUS"]==="Hold" || original["IsFactoryOut"] === 1 || original["STATUS"] === "Pending"}
              >
                Upload
              </Button>
            </>
          );
        }
      }
      return "-";
    }
  } else return `${getValueOrDash(value)}`;
};

export const defaultColumn = {
  Cell: AggregateEditableCell,
};
